var map = {
	"./agency.png": 912,
	"./dimiri.png": 38,
	"./drishti.png": 803,
	"./heartcare.png": 806,
	"./hyperswitch.png": 137,
	"./needforblood.png": 167,
	"./portfolio.png": 718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;